import React, { createContext, useContext } from "react";

import { TealiumEvent, TealiumProviderProps, Utag } from "./types";
import { getGAClientId } from "../../utils/getGAClientId";
import { initialiseTelium } from "./tealium";

declare const utag: Utag | undefined;
declare const window: Window &
  typeof globalThis & {
    hj: any;
  };
const isProduction = process.env.NODE_ENV === "production";

export const TealiumContext = createContext<{
  trackEvent: (event: TealiumEvent) => void;
  trackPageView: (pathname: string) => void;
}>({
  trackEvent: () => {},
  trackPageView: () => {},
});

export const trackPageView = (pathname: string) => {
  if (typeof utag !== "undefined") {
    utag.view({ page_name: pathname });
    if (window.hj) {
      hotjarIdentifyAPI();
    }
  }
};

export const trackEvent = ({
  eventCategory,
  eventAction,
  eventLabel,
  eventValue,
}: TealiumEvent) => {
  if (typeof utag !== "undefined") {
    utag.link({
      eventCategory,
      eventAction,
      eventLabel,
      eventValue,
    });
  }
};

export const hotjarUserAttributes = () => {
  window.hj =
    window.hj ||
    function (...args: any) {
      (window.hj.q = window.hj.q || []).push(args);
    };
  hotjarIdentifyAPI();
};

export const hotjarIdentifyAPI = () => {
  const userId = getGAClientId() || null;
  window.hj("identify", userId, {});
};

export const useTealium = () => useContext(TealiumContext);
export const TealiumProvider: React.FC<TealiumProviderProps> = ({
  trackEventFn,
  children,
}) => {
  if (isProduction && typeof utag === "undefined") {
    initialiseTelium();
    hotjarUserAttributes();
  }

  return (
    <TealiumContext.Provider
      value={{
        trackEvent: trackEventFn || trackEvent,
        trackPageView,
      }}
    >
      {children}
    </TealiumContext.Provider>
  );
};
